import { BrowserRouter } from 'react-router-dom'
import { AppRouter } from './app/router'
import { AuthProvider } from './modules/auth/components/AuthProvider'
import { ToastProvider } from './shared/components/Toast'
import { OfflineIndicator } from './shared/components/OfflineIndicator'

export function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <AppRouter />
          <OfflineIndicator />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  )
}
